import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import authService from '../services/auth.service';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authService.login(email, password);
      window.location.href = '/dashboard';
    } catch (err: any) {
      setError(err.response?.data?.message || 'Credenciales incorrectas. Intente de nuevo.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Left branding panel */}
      <div className="login-branding">
        <div className="login-branding-inner">
          <div className="login-brand-logo">
            <img src="/exia-crm-logo.svg" alt="EXIA CRM Jurídico" style={{ width: '260px', height: 'auto' }} />
          </div>
          <p className="login-brand-desc">
            Plataforma integral de gestión para despachos jurídicos
          </p>
          <div className="login-brand-features">
            <div className="login-feature-item">
              <span className="login-feature-dot" />
              Gestión de Casos y Expedientes
            </div>
            <div className="login-feature-item">
              <span className="login-feature-dot" />
              Control de Audiencias
            </div>
            <div className="login-feature-item">
              <span className="login-feature-dot" />
              Seguimiento de Tareas
            </div>
            <div className="login-feature-item">
              <span className="login-feature-dot" />
              Adjuntos y Documentos
            </div>
          </div>
        </div>
      </div>

      {/* Right form panel */}
      <div className="login-form-panel">
        <div className="login-form-inner">
          <div className="login-form-header">
            <div className="login-mobile-logo d-md-none">
              <span style={{ display: 'inline-block', background: '#313a46', borderRadius: '8px', padding: '10px 16px' }}>
                <img src="/exia-crm-logo.svg" alt="EXIA CRM Jurídico" style={{ width: '180px', height: 'auto' }} />
              </span>
            </div>
            <h2>Bienvenido</h2>
            <p>Ingresa tus credenciales para continuar</p>
          </div>

          {error && (
            <Alert variant="danger" className="login-alert">
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Correo Electrónico</Form.Label>
              <div className="login-input-wrapper">
                <span className="login-input-icon">
                  <FiMail size={16} />
                </span>
                <Form.Control
                  type="email"
                  placeholder="usuario@empresa.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="login-input"
                  required
                  autoFocus
                />
              </div>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Contraseña</Form.Label>
              <div className="login-input-wrapper">
                <span className="login-input-icon">
                  <FiLock size={16} />
                </span>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="login-input login-input-password"
                  required
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </Form.Group>

            <Button
              type="submit"
              className="w-100 login-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" animation="border" className="me-2" />
                  Verificando...
                </>
              ) : (
                'Iniciar Sesión'
              )}
            </Button>
          </Form>

          <div className="login-footer">
            <small>
              &copy; {new Date().getFullYear()} AS Software &middot; CRM Jurídico
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
